module.exports = __webpack_public_path__ + "assets/img/course3.628e8d27.png";